import {useCallback, useLayoutEffect, useRef} from "react";

const KEYBOARD_COVER_THRESHOLD_PX = 120;

/**
 * Keeps a react-modal content fitted to the visual viewport while the on-screen keyboard is open.
 * Attach the returned ref to any element inside the modal content.
 */
export const useKeyboardFitModalContent = (isActive: boolean) => {
    const frameRef = useRef<HTMLElement | null>(null);
    const setFrameRef = useCallback((node: HTMLElement | null) => {
        frameRef.current = node;
    }, []);

    useLayoutEffect(() => {
        const frame = frameRef.current;
        const viewport = window.visualViewport;
        const content = frame?.closest(".ReactModal__Content") as HTMLElement | null;

        if (!frame || !viewport || !content || !isActive) return;

        const syncToKeyboard = () => {
            const covered = window.innerHeight - viewport.height - viewport.offsetTop;

            if (covered < KEYBOARD_COVER_THRESHOLD_PX) {
                content.style.removeProperty("bottom");
                content.style.removeProperty("height");
                content.style.removeProperty("top");
                return;
            }

            content.style.top = `${viewport.offsetTop}px`;
            content.style.bottom = "auto";
            content.style.height = `${viewport.height}px`;
        };

        syncToKeyboard();
        viewport.addEventListener("resize", syncToKeyboard);
        viewport.addEventListener("scroll", syncToKeyboard);

        return () => {
            viewport.removeEventListener("resize", syncToKeyboard);
            viewport.removeEventListener("scroll", syncToKeyboard);
            content.style.removeProperty("bottom");
            content.style.removeProperty("height");
            content.style.removeProperty("top");
        };
    }, [isActive]);

    return setFrameRef;
};
import {useCallback, useLayoutEffect, useRef} from "react";

const KEYBOARD_COVER_THRESHOLD_PX = 120;

/**
 * Keeps a react-modal content fitted to the visual viewport while the on-screen keyboard is open.
 * Attach the returned ref to any element inside the modal content.
 */
export const useKeyboardFitModalContent = (isActive: boolean) => {
    const frameRef = useRef<HTMLElement | null>(null);
    const setFrameRef = useCallback((node: HTMLElement | null) => {
        frameRef.current = node;
    }, []);

    useLayoutEffect(() => {
        const frame = frameRef.current;
        const viewport = window.visualViewport;
        const content = frame?.closest(".ReactModal__Content") as HTMLElement | null;

        if (!frame || !viewport || !content || !isActive) return;

        const syncToKeyboard = () => {
            const covered = window.innerHeight - viewport.height - viewport.offsetTop;

            if (covered < KEYBOARD_COVER_THRESHOLD_PX) {
                content.style.removeProperty("bottom");
                content.style.removeProperty("height");
                content.style.removeProperty("top");
                return;
            }

            content.style.top = `${viewport.offsetTop}px`;
            content.style.bottom = "auto";
            content.style.height = `${viewport.height}px`;
        };

        syncToKeyboard();
        viewport.addEventListener("resize", syncToKeyboard);
        viewport.addEventListener("scroll", syncToKeyboard);

        return () => {
            viewport.removeEventListener("resize", syncToKeyboard);
            viewport.removeEventListener("scroll", syncToKeyboard);
            content.style.removeProperty("bottom");
            content.style.removeProperty("height");
            content.style.removeProperty("top");
        };
    }, [isActive]);

    return setFrameRef;
};
